import { getText } from '@storebrand-digital/fms-translations';
import { ProductName } from 'Constants/products.constants';
import { FmsKeys } from 'Types/FmsTypes';

export const getAppText = getText<FmsKeys>;
export const replaceVariables = (
  stringWithVariables: string,
  replacements: string[],
): string => {
  const regex = /{{(.*?)}}/g;
  let index = 0;
  const replacedString = stringWithVariables.replace(regex, () => {
    if (index >= replacements.length) {
      throw new Error(
        'There are more placeholders than provided replacements.',
      );
    }
    const replacement = replacements[index];
    index += 1;
    return replacement;
  });

  // Check if there are any remaining placeholders in the replaced string
  const remainingPlaceholders = replacedString.match(regex);
  if (remainingPlaceholders || index < replacements.length) {
    throw new Error('There are more provided replacements than placeholders.');
  }

  return replacedString;
};

/* translates insuranceName into a string key used in fms */
export function getFMSInsuranceName(insuranceName: ProductName): string {
  switch (insuranceName) {
    case ProductName.CAR: {
      return 'car';
    }
    case ProductName.BOAT: {
      return 'boat';
    }
    case ProductName.MOTORCYCLE: {
      return 'mc';
    }
    case ProductName.VETERAN_CAR: {
      return 'veteran';
    }
    case ProductName.MOPED: {
      return 'moped';
    }
    case ProductName.ELECTRIC_SCOOTER: {
      return 'electricScooter';
    }
    case ProductName.CARAVAN: {
      return 'caravan';
    }
    case ProductName.TRACTOR: {
      return 'tractor';
    }
    case ProductName.TRAILER: {
      return 'trailer';
    }
    case ProductName.HOUSE: {
      return 'house';
    }
    case ProductName.CABIN: {
      return 'cabin';
    }
    case ProductName.HOUSE_CONTENTS: {
      return 'houseContents';
    }
    case ProductName.HOUSE_CONTENTS_AGREEMENT: {
      return 'houseContentsAgreement';
    }
    case ProductName.AKA_HOUSE_CONTENTS: {
      return 'akaHouseContents';
    }
    case ProductName.HOUSE_CONTENTS_STB_AGREEMENT: {
      return 'stbHouseContents';
    }
    case ProductName.HUSEIERNE_HOUSE_CONTENTS: {
      return 'huseierneHouseContents';
    }
    case ProductName.CABIN_CONTENTS: {
      return 'cabinContents';
    }
    case ProductName.VALUABLE: {
      return 'valuable';
    }
    case ProductName.ANIMAL: {
      return 'animal';
    }
    case ProductName.TRAVEL: {
      return 'travel';
    }
    case ProductName.AKA_TRAVEL: {
      return 'akaTravel';
    }
    case ProductName.CHILD: {
      return 'child';
    }
    case ProductName.NEW_CHILD: {
      return 'newchild';
    }
    case ProductName.AKA_CHILD: {
      return 'akaChild';
    }
    case ProductName.PREGNANT_AND_NEWBORN: {
      return 'pregnantAndNewborn';
    }
    case ProductName.DEATH: {
      return 'death';
    }
    case ProductName.AKA_HEALTH: {
      return 'akaHealth';
    }
    case ProductName.AKA_GROUP_LIFE: {
      return 'akaGroupLife';
    }
    case ProductName.AKA_CRITICAL_ILLNESS: {
      return 'akaCriticalIllness';
    }
    case ProductName.AKA_FAMILY_ACCIDENT: {
      return 'akaFamilyAccident';
    }
    case ProductName.AURORA_CHILD: {
      return 'auroraChild';
    }
    case ProductName.AURORA_CHILD_COMPLETE: {
      return 'auroraChildComplete';
    }
    case ProductName.AURORA_DISABILITY_TOTAL: {
      return 'auroraDisabilityTotal';
    }
    case ProductName.AURORA_DISABILITY_INTEREST: {
      return 'auroraDisabilityInterestInsurance';
    }
    case ProductName.ACCIDENT: {
      return 'accident';
    }
    default:
      return 'insuranceName';
  }
}
